import React, { useState } from "react";
import "./DeleteAccount.css";
import logo from "../assets/images/logo_cyber_112.png";

const DeleteAccountScreen = () => {
  const [email, setEmail] = useState("");

  const handleDeleteRequest = (e) => {
    e.preventDefault();

    if (!email) {
      alert("Please enter your email address first.");
      return;
    }

    const subject = encodeURIComponent("Cyber112 Account Deletion Request");
    const body = encodeURIComponent(
      `Hello Cyber112 Team, I would like to request deletion of my Cyber112 account associated with this email: ${email}. Thank you.`
    );

    // 🔥 Otvara Gmail direktno sa popunjenim mailom
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=support@cyber112.com&su=${subject}&body=${body}`;
    window.open(gmailLink, "_blank");
  };

  return (
    <div className="delete-container">
      <div className="delete-card">
        <img src={logo} alt="Cyber112 Logo" className="delete-logo" />

        <h2 className="delete-title">Delete Your Account</h2>
        <p className="delete-subtitle">
          Enter your email below to send a deletion request.
        </p>

        <form onSubmit={handleDeleteRequest}>
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="delete-input"
          />

          <button type="submit" className="delete-button">
            Permanently Delete
          </button>
        </form>

        <p className="delete-warning">
          ⚠️ Once deleted, your account and data cannot be recovered.
        </p>
      </div>
    </div>
  );
};

export default DeleteAccountScreen;